import { ProductCatalogAttributeSelectionType } from '@graphql/generated-base';
import type { RefinementFacetProps } from '../RefinementFacet.types';

export * from './StringListItem';

import { RefinementFacetStringList } from './RefinementFacetStringList';
import { RefinementFacetPriceRange } from './RefinementFacetPriceRange';

export const COMPONENT_BY_FACET_VARIANT: Record<ProductCatalogAttributeSelectionType, (React.ComponentType<RefinementFacetProps> & { Skeleton?: () => JSX.Element }) | null> = {
  [ProductCatalogAttributeSelectionType.stringListMulti]: RefinementFacetStringList,
  [ProductCatalogAttributeSelectionType.colorListMulti]: null,
  [ProductCatalogAttributeSelectionType.imageListMulti]: null,
  [ProductCatalogAttributeSelectionType.priceBucket]: null,
  [ProductCatalogAttributeSelectionType.priceRange]: RefinementFacetPriceRange,
} as const;
